import * as localforage from 'localforage';

export const storage = {
  get (key) {
    if (!('localStorage' in window) || !key) {
      return null;
    };
    let strparse = JSON.parse(localStorage.getItem(key) || '{}');
    // console.log('storage=>get=>', strparse);
    if (strparse.time && +strparse.time < Date.now()) {
      localStorage.removeItem(key);
      return null;
    };
    return strparse.value;
  },
  set (key, value, time) {
    if (!('localStorage' in window) || !key) {
      return false;
    };
    let item = {};
    item.value = value;
    if (time && time > 0) {
      item.time = time * 60 * 1000 + Date.now();
    };
    // console.log('storage=>set=>', item);
    localStorage.setItem(key, JSON.stringify(item));
    return true;
  },
  /**
     * 使用 localforage 异步获取存储数据
     * @param key 存储键名
     * @returns Promise<any> 存储的值或 null
     */
  async getByForage (key) {
    if (!key) {
      return null;
    }
    try {
      // 直接获取存储的字符串数据（与 localStorage 一致）
      const storedString = await localforage.getItem(key);
      if (!storedString) {
        return null;
      }
    
      // 与 get 方法保持完全一致：解析 JSON 字符串
      const strparse = JSON.parse(storedString || '{}');
    
      // 检查过期时间
      if (strparse.time && +strparse.time < Date.now()) {
        // 数据已过期，删除并返回 null
        await localforage.removeItem(key);
        return null;
      }
      // 与 get 方法保持完全一致：返回 value 属性
      return strparse.value;
    } catch (error) {
      console.error('Error getting data from localforage:', error);
      return null;
    }
  },

  /**
 * 使用 localforage 异步设置存储数据
 * @param key 存储键名
 * @param value 要存储的值
 * @param time 过期时间（分钟）
 * @returns Promise<boolean> 操作是否成功
 */
  async setByForage (key, value, time) {
    if (!key) {
      return false;
    }
            
    try {
    // 与 set 方法保持完全一致：构建相同的 item 结构
      let item = {};
      item.value = value;
      if (time && time > 0) {
        item.time = time * 60 * 1000 + Date.now();
      }
        
      // 与 set 方法保持完全一致：JSON.stringify 整个 item
      await localforage.setItem(key, JSON.stringify(item));
      return true;
    } catch (error) {
      console.error('Error setting data to localforage:', error);
      return false;
    }
  }
}